<p-card>
  <ng-template pTemplate="header">
    <div class="flex justify-content-end p-3">
      <p-button icon="pi pi-times"
                styleClass="p-button-rounded p-button-text sc-grey"
                (onClick)="hideWelcomeBlock()">
      </p-button>
    </div>
  </ng-template>
  <div class="flex flex-column align-items-center py-5">
    <div class="title3Font"
         i18n>
      Welcome to Scientific!
    </div>
    <div class="body2Font mt-2"
         i18n>
      Start you first interaction from video guide to understand all process and tool
    </div>
    <div class="mt-5">
      <p-button label="Watch video"
                i18n-label
                styleClass="p-button-outlined">
      </p-button>
    </div>
  </div>
</p-card>